import { createRouter, createWebHistory } from 'vue-router'
import type { RouterScrollBehavior } from 'vue-router'
import { isAuthenticated } from '@/utils/auth'
import MainLayout from '@/views/MainPage/index.vue'
import Login from '@/views/Login/index.vue'

const PublicopinionDetail = () => import('@/views/PublicopinionDetail/index.vue')
const PublicopinionDashboard = () => import('@/views/PublicopinionDashboard/index.vue')
const PublicopinionContent = () => import('@/views/PublicopinionContent/index.vue')
const AccountPostList = () => import('@/views/AccountPostList/index.vue')
const ArchiveDashboard = () => import('@/views/ArchiveDashboard/index.vue')
const ArchiveDetail = () => import('@/views/ArchiveDashboard/subpage/ArchiveDetails/index.vue')
const ProcessMonitor = () => import('@/views/ProcessMonitor/index.vue')
const InternalDetails = () => import('@/views/InternalDetails/index.vue')
const InternalDetailsNext = () => import('@/views/InternalDetailsNext/index.vue')
const ZmnDetails = () => import('@/views/InternalDetailsNext/components/ZmnDetails.vue')
const YeyxDetails = () => import('@/views/InternalDetailsNext/components/YeyxDetails.vue')
const ComplaintDetailsYeyx = () => import('@/views/InternalDetailsNext/components/ComplaintDetailsYeyx.vue')
const ComplaintDetailsZmn = () => import('@/views/InternalDetailsNext/components/ComplaintDetailsZmn.vue')
const PersonalInformation = () => import('@/views/PersonalInformation/index.vue')
const AuthorityManagement = () => import('@/views/AuthorityManagement/index.vue')
const CompetentAuthority = () => import('@/views/MediaResource/CompetentAuthority/index.vue')
const MediaResourceDashboard = () => import('@/views/MediaResource/MediaResourceDashboard/index.vue')
const ServiceProvider = () => import('@/views/MediaResource/ServiceProvider/index.vue')
const MediaLibrary = () => import('@/views/MediaResource/MediaLibrary/index.vue')
const MediaReport = () => import('@/views/MediaResource/MediaReport/index.vue')
const MediaDetails = () => import('@/views/MediaResource/MediaDetails/index.vue')
const Rectification = () => import('@/views/Accountability/Rectification/index.vue')
const RectificationDetails = () => import('@/views/Accountability/RectificationDetails/index.vue')
const TaskTrack = () => import('@/views/Accountability/Rectification/components/TaskTrack.vue')
const AccountabilityDashboard = () => import('@/views/Accountability/AccountabilityDashboard/index.vue')
const AccountabilityList = () => import('@/views/Accountability/AccountabilityList/index.vue')
const SearchPanel = () => import('@/views/InternalDetailsNext/index.vue')
const TaskDistribution = () => import('@/views/H5/index.vue')
const MediaTaskDetails = () => import('@/views/MediaResource/MediaLibrary/components/MediaTaskDetails.vue')
const ComplaintContentZmn = () => import('@/views/InternalDetailsNext/components/ComplaintContentZmn.vue')
const ComplaintContentYeyx = () => import('@/views/InternalDetailsNext/components/ComplaintContentYeyx.vue')
const Home = () => import('@/views/Home/index.vue')
const ExpenseList = () => import('@/views/CostBudget/ExpenseList/index.vue')
const CostBudgetDashboard = () => import('@/views/CostBudgetDashboard/index.vue')
const ExpenseDetails = () => import('@/views/CostBudget/ExpenseList/components/ExpenseDetails.vue')
const BudgetAllocation = () => import('@/views/CostBudget/BudgetAllocation/index.vue')

// 定义滚动行为，导航时滚动到顶部
const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  }

  return {
    el: '#main-scroller',
    top: 0,
    left: 0
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login,
      name: 'Login',
      meta: { title: '登录' },
    },
    {
      path: '/web/task-distribution',
      component: TaskDistribution,
      name: 'TaskDistribution',
      meta: { title: '任务派发' },
    },
    {
      path: '/web',
      component: MainLayout, //使用主布局
      children: [
        {
          path: '',
          redirect: { name: 'Home' },
        },
        {
          path: 'home',
          component: Home,
          name: 'Home',
          meta: { title: '首页' },
        },
        {
          path: 'public-opinion-detail',
          component: PublicopinionDetail,
          name: 'PublicopinionDetail',
          meta: { title: '舆情详情',requiresAuth:true,module:'monitorDetails'},
        },
        {
          path: 'public-opinion-dashboard',
          component: PublicopinionDashboard,
          name: 'PublicopinionDashboard',
          meta: { title: '舆情看板',requiresAuth:true,module:'monitorDashboard'},
        },
        {
          path: 'public-opinion-content/:id', // 动态路由 id
          component: PublicopinionContent,
          name: 'PublicopinionContent',
          props: true, // ✅ 这样组件可以直接用 props 接收 id
          meta: { title: '舆情内容' },
        },
        {
          path: 'account-posts/:uniqueId/:type',
          component: AccountPostList,
          name: 'AccountPostList',
          props: true,
          meta: { title: '账号帖子' },
        },
        {
          path: 'internal-details',
          component: InternalDetails,
          name: 'InternalDetails',
          meta: { title: '内部详情',requiresAuth:true,module:'taskInternal'},
        },
        {
          path: 'internal-details-next',
          component: InternalDetailsNext,
          name: 'InternalDetailsNext',
          meta: { title: '内部详情' },
        },
        {
          path: 'zmn-details/:id',
          component: ZmnDetails,
          name: 'ZmnDetails',
          props: true,
          meta: { title: 'Zmn工单详情' },
        },
        {
          path: 'yeyx-details/:id?',
          component: YeyxDetails,
          name: 'YeyxDetails',
          props: true,
          meta: { title: '言而有信工单详情' },
        },
        {
          path: 'SearchPanel',
          component: SearchPanel,
          name: 'SearchPanel',
          props: true,
          meta: { title: '搜索面板' },
        },
        {
          path: 'complaint-details-yeyx/:id',
          component: ComplaintDetailsYeyx,
          name: 'ComplaintDetailsYeyx',
          props: true,
          meta: { title: '言而有信投诉详情' },
        },
        {
          path: 'complaint-details-zmn/:id',
          component: ComplaintDetailsZmn,
          name: 'ComplaintDetailsZmn',
          props: true,
          meta: { title: '啄木鸟投诉详情' },
        },
        {
          path: 'complaint-content-yeyx/:id',
          component: ComplaintContentYeyx,
          name: 'ComplaintContentYeyx',
          props: true,
          meta: { title: '言而有信投诉内容' },
        },
        {
          path: 'complaint-content-zmn/:id',
          component: ComplaintContentZmn,
          name: 'ComplaintContentZmn',
          props: true,
          meta: { title: '啄木鸟投诉内容' }
        },
        {
          path: 'archive-dashboard',
          component: ArchiveDashboard,
          name: 'ArchiveDashboard',
          meta: { title: '归档看板', requiresAuth:true,module:'taskArchive'},
        },
        {
          path: 'archive-detail',
          component: ArchiveDetail,
          name: 'ArchiveDetail',
          meta: { title: '归档详情' },
        },
        {
          path: 'process-monitor',
          component: ProcessMonitor,
          name: 'ProcessMonitor',
          meta: { title: '流程监听',requiresAuth:true,module:'taskMonitor'},
        },
        {
          path: 'personal-information',
          component: PersonalInformation,
          name: 'PersonalInformation',
          meta: { title: '个人信息' },
        },
        {
          path: 'authority-management',
          component: AuthorityManagement,
          name: 'AuthorityManagement',
          meta: { title: '权限管理' },
        },
        {
          path: 'competent-authority',
          component: CompetentAuthority,
          name: 'CompetentAuthority',
          meta: { title: '主管部门',requiresAuth:true,module:'mediaAuthority'},
        },
        {
          path: 'MediaResource-Dashboard',
          component: MediaResourceDashboard,
          name: 'MediaResourceDashboard',
          meta: { title: '媒体资源看板',requiresAuth:true,module:'mediaResources'},
        },
        {
          path: 'service-provider',
          component: ServiceProvider,
          name: 'ServiceProvider',
          meta: { title: '合作服务商',requiresAuth:true,module:'mediaServicer'},
        },
        {
          path: 'media-library',
          component: MediaLibrary,
          name: 'MediaLibrary',
          meta: { title: '媒体管理' ,requiresAuth:true,module:'mediaDetails'},
        },
        {
          path: 'media-report',
          component: MediaReport,
          name: 'MediaReport',
          meta: { title: '媒体报道',requiresAuth:true,module:'mediaList'},
        },
        {
          path: 'media-details/:id', // 注意：这里不需要写完整的/web，因为是在children下面
          component: MediaDetails,
          name: 'MediaDetails',
          props: true, // 将路由参数传递给组件
          meta: {
            title: '媒体详情',
            category: 'media',
            parent: 'MediaLibrary',
            parentRoute: '/web/media-library' // 注意：这里要写完整的路径，包括/web
          }
        },
        {
          path: 'media-task/:id',
          component: MediaTaskDetails,
          name: 'MediaTask',
          meta: { title: '媒体任务'},
        },
        {
          path: 'rectification',
          component: Rectification,
          name: 'Rectification',
          meta: { title: '整改任务' ,requiresAuth:true,module:'accountabilityProcess'},
        },
        {
          path: 'rectification-details/:id',
          component: RectificationDetails,
          name: 'RectificationDetails',
          props: true,
          meta: { title: '事件详情' },
        },

        {
          path: 'accountability/rectification/task-track',
          component: TaskTrack,
          name: 'TaskTrack',
          meta: { title: '任务追踪' },
        },

        // ========== 只修改你的追责详情路由这一段，其他路由全部原样 ==========
        {
          path: 'rectification-details/:id', // ✅ 你的路由path 完全不变！！不改名、不改前缀！！
          component: RectificationDetails,   // ✅ 你的文件 完全不变！！
          name: 'RectificationDetails',      // ✅ 你的路由name 完全不变！！
          props: true,                       // ✅ 和舆情一致
          meta: {
            title: '事件详情',                // ✅ 你的标题 完全不变！！
            source: 'accountablity'          // ✅ 只加这1个字段！！面包屑组件能识别的标识！
          },
        },
// ========== 追责看板/列表路由 也只加这个字段，其他不变 ==========
        {
          path: 'accountablity-dashboard',
          component: AccountabilityDashboard,
          name: 'AccountabilityDashboard',
          meta: { title: '追责看板', source: 'accountablity' ,requiresAuth:true,module:'accountabilityDashboard'}
        },
        {
          path: 'accountablity-list',
          component: AccountabilityList,
          name: 'AccountabilityList',
          meta: { title: '追责列表', source: 'accountablity' ,requiresAuth:true,module:'accountabilityWorkorder'}
        },
        {
          path: 'expense-list',
          component: ExpenseList,
          name: 'ExpenseList',
          meta: { title: '成本支出列表' ,requiresAuth:true,module:'costDetails'},
        },
        {
          path: 'costbudgetdashboard',
          component: CostBudgetDashboard,
          name: "CostBudgetDashboard",
          meta: {title: '成本看板',requiresAuth:true,module:'costDashboard'}
        },
        {
          path: 'expenseDetails/:id',
          component: ExpenseDetails,
          name: "expenseDetails",
          props: true,
          meta: {title: '成本详情'}
        },
        {
          path:'budgetallocation',
          component:BudgetAllocation,
          name: "BudgetAllocation",
          meta:{title: '预算分配',requiresAuth:true,module:'budgetAllocation'}
        }
      ],
      meta: { requiresAuth: true }, // 标记需要认证
    },
  ],
  scrollBehavior: scrollBehavior,
})
import { useUserStore } from '@/stores/user'
// 路由守卫 - 基本的登录状态检查
// 注意：这里只做基本检查（cookie是否存在），真正的JWT验证由后端处理
// 如果JWT无效，后端会返回401，前端拦截器会处理跳转
router.beforeEach(async(to, from, next) => {
  // 重置所有可能的缩放影响，避免页面切换时渲染错误
  const scaleElements = document.querySelectorAll('[class*="-embed-scale"]')
  scaleElements.forEach((el) => {
    (el as HTMLElement).style.transform = 'scale(1)'
  })
  const userStore=useUserStore()

  // 检查路由是否需要认证
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated()) {
    // 没有基本的登录cookie，跳转到登录页
    next('/login')
  }
  if (to.path === '/login' && isAuthenticated()) {
    // 已有登录cookie，访问登录页时跳转到主页
    next('/web/')
  }
  if (isAuthenticated() && !userStore.initialized) {
    await userStore.fetchUserInfo() // 必须等待接口返回
  }

  // 3. 模块权限检查
  if (to.meta.module) {
    const moduleName = to.meta.module as string

    if (!userStore.hasModuleAuth(moduleName)) {
      console.warn(`无权访问模块: ${moduleName}`)
      // 权限不足，返回来源页或首页
      return next(from.path && from.path !== '/' ? from.path : '/web/home')
    }

    // 🔥 关键修复：如果权限检查通过，必须调用 next() 否则页面会卡死！！
    next()
  } else {
    // 没有 meta.module 的页面（如首页）直接放行
    next()
  }

})

// 路由切换后的处理
router.afterEach(() => {
  // 延迟触发 window resize 事件，让 ECharts 重新计算尺寸
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 100)

  // 再次延迟触发，确保所有组件都已挂载
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 300)
})

export default router
